import React from "react";
import NavigationBanner from "../../components/common/NavigationBanner";
import HeaderBg from "../../Assets/Images/Bannerimage.png";
import AFSAProgrammes from "../../components/user/NewHome/AFSAProgrammes"

const OurWork = () => {
  return (
    <div className="pb-10">
      <NavigationBanner title={"Our Work"} background={HeaderBg} />
      <AFSAProgrammes />
    </div>
  );
};
export default OurWork;